import { getFormattedDate } from '@app/utils/date'
import { dateFormat } from '@app/constants'

import type { TableData } from '@app/types/table'
import type { ResponseDto } from '@app/api/dtos'
import type { MonitoringTaskDto, ContractorSectionPageFilterData } from '@app/api/routes/monitoringTasks/dtos'
import type { ContractorSectionDataSource } from '../types'
import type { DecodedValueMap } from 'use-query-params'
import type { QueryParamConfigMap } from 'serialize-query-params'

export const adaptContractorSectionTableData = (
  monitoringTaskResponse: ResponseDto<MonitoringTaskDto>
): TableData<ContractorSectionDataSource> => {
  const { count, results: monitoringTask } = monitoringTaskResponse

  const dataSource: ContractorSectionDataSource[] = monitoringTask.map(dto => ({
    key: dto.id,
    monitoringId: dto.id,
    monitoringType: dto.monitoringType?.name ?? null,
    date: getFormattedDate(dto.monitoringStartAt, dateFormat.DD_MM_YYYY_HH_mm),
    store: dto.store?.name ?? null,
    cluster: dto.cluster?.name ?? null,
    status: dto.status
    // loadingPrices: dto.productMonitoring.promoPrice ?? dto.productMonitoring.regularPrice ?? dto.productMonitoring.note,
    // uploadingPhotos: dto.productMonitoring.photoLinks,
    // matchingStatus: dto.productMonitoring.matchingStatus
  }))

  return { count, dataSource }
}

export const adaptContractorSectionPageFilterData = (
  queryParams: DecodedValueMap<QueryParamConfigMap>
): ContractorSectionPageFilterData => {
  return {
    monitoringTypeIds: queryParams.monitoringTypeIds,
    storeIds: queryParams.storeIds,
    clusterIds: queryParams.clusterIds,
    salesOrganizationIds: queryParams.salesOrganizationIds,
    status: queryParams.status,
    createdAtAfter: queryParams.createdAtAfter,
    createdAtBefore: queryParams.createdAtBefore,
    showStopped: queryParams.showStopped
  }
}
